import clientTranslations from "@src/modules/client/_langs/fr-CA";
import importTranslations from "@src/modules/member/components/import/_langs/fr-CA";
import { rayaLucariaFrCA } from "@src/raya-lucaria/i18n";
import { geoFrCA } from "@src/raya-lucaria/utils/geo-i18n-fr-CA";

export default {
  "Delete Item": "Supprimer l'élément",
  countries: geoFrCA.countries,
  states: geoFrCA.states,
  controls: {
    combobox: {
      selectAll: "Tout sélectionner",
      deselectAll: "Tout désélectionner",
      clear: "Effacer",
      selected: "{{count}} sélectionné(s)",
      more: "+{{count}} de plus",
      showLess: "Afficher moins",
      empty: "Aucun résultat",
      searchPlaceholder: "Rechercher…",
      create: "Créer",
      unavailable: "Indisponible",
      loading: "Chargement…",
    },
  },
  language: "fr-CA",
  languageWord: "Français",
  close: "Fermer",
  discard: "Abandonner",
  saveImage: "Enregistrer l'image",
  cropImageFailed:
    "Désolé, cette image n'a pas pu être préparée pour le téléversement. Réessayez ou choisissez une image plus petite.",
  cropProfileImage: "Rogner la photo de profil",
  cropOrganizationImage: "Rogner l'image de l'organisation",
  cropInvoiceLogo: "Rogner le logo de la facture",
  cropImageDescription:
    "Utilisez la roulette de la souris pour faire un zoom avant ou arrière. Faites glisser l'image pour la déplacer.",
  download: "Télécharger",
  settings: "Paramètres",
  accountMenu: "Menu du compte et de l'organisation",
  copyPaymentLink: "Copier le lien de paiement",
  copyPaymentLinkUnavailable:
    "Disponible lorsque Stripe est connecté comme passerelle de paiement",
  paymentLinkCopied: "Lien de paiement copié",
  send: "Envoyer",
  invoiceNumber: "Numéro de facture",
  processingFee: "Frais de traitement",
  payNow: "Payer {{amount}} maintenant",
  poweredBy: "Propulsé par",
  invoiceAlreadyPaid: "Facture déjà payée",
  paymentProcessorNotSupported: "Processeur de paiement non pris en charge",
  clientM: clientTranslations,
  member: {
    import: importTranslations,
    main: {
      contracts: {
        contracts: "Contrats",
        newContract: "Nouveau contrat",
        columns: {
          title: "Titre",
          contractNumber: "N° de contrat",
          status: "Statut",
          signers: "Signataires",
          updated: "Mis à jour",
          actions: "Actions",
        },
        status: {
          draft: "Brouillon",
          sent: "Envoyé",
          partially_signed: "Signé en partie",
          executed: "Exécuté",
          voided: "Annulé",
        },
        rowActions: {
          menuLabel: "Actions du contrat",
          view: "Afficher",
          send: "Envoyer pour signature",
          resend: "Renvoyer pour signature",
          downloadSealed: "Télécharger la copie scellée",
          downloadCertificate: "Télécharger le certificat",
          delete: "Supprimer",
        },
        empty: {
          title: "Aucun contrat pour le moment",
          subtitle:
            "Envoyez un PDF finalisé pour signature électronique — Invup suit chaque signataire et scelle la copie exécutée.",
        },
        modal: {
          title: "Nouveau contrat",
          subtitle:
            "Téléversez un document PDF ou Word finalisé pour créer un brouillon.",
          contractTitle: "Titre du contrat",
          contractTitlePlaceholder: "p. ex. Contrat-cadre de services",
          project: "Projet",
          projectPlaceholder: "Associer à un projet",
          projectInfo: "Optionnel. Rattache le contrat exécuté à un projet.",
          document: "Document",
          documentPlaceholder: "Choisissez un fichier ou glissez-déposez",
          documentHint: "PDF ou DOCX · jusqu’à 20 Mo",
          create: "Créer le brouillon",
          errorSummary: "Vérifiez les champs indiqués",
          titleRequired: "Saisissez un titre de contrat.",
          documentRequired: "Téléversez un document PDF ou Word.",
        },
        send: {
          title: "Envoyer pour signature",
          subtitle:
            "Chaque signataire reçoit son propre lien privé pour signer.",
          ownInbox: "boîte personnelle",
          sharedInbox: "boîte partagée",
          roleTitle: "Les boîtes partagées ne peuvent pas signer",
          roleBody:
            "Chaque signataire doit être une personne nommée avec sa propre boîte de réception. Remplacez les adresses partagées comme billing@ ou info@ avant l’envoi.",
          incompleteTitle: "Envoi impossible",
          incompleteBody:
            "Ajoutez un signataire et placez au moins un champ avant l’envoi.",
          cancel: "Annuler",
          send: "Envoyer",
          sendFailed:
            "Désolé, ce contrat n’a pas pu être envoyé en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
          successTitle: "Envoyé pour signature",
          successBodyOne:
            "Envoyé à {{count}} signataire — ce contrat est maintenant verrouillé.",
          successBodyOther:
            "Envoyé à {{count}} signataires — ce contrat est maintenant verrouillé.",
          sentLocked: "envoyé · verrouillé",
        },
        resend: {
          title: "Renvoyer pour signature",
          confirm: "Renvoyer",
          confirmAll:
            "Renvoyer le lien de signature à tous ceux qui n’ont pas encore signé ?",
          confirmSigner: "Renvoyer le lien de signature à {{name}} ?",
          resendAll: "Tout renvoyer",
        },
        editor: {
          back: "Retour aux contrats",
          send: "Envoyer",
          page: "Page",
          of: "de",
          signers: "Signataires",
          fields: "Champs",
          selectedField: "Champ sélectionné",
          addSigner: "Ajouter un signataire",
          addSignerFirst: "Ajoutez un signataire avant de placer des champs.",
          cancel: "Annuler",
          add: "Ajouter",
          fieldsHint:
            "Ajoutez un champ, puis glissez-le à sa place et assignez un signataire.",
          inspectorEmpty:
            "Sélectionnez un champ sur la page pour modifier son type, sa page et son signataire.",
          type: "Type",
          pageLabel: "Page",
          assignTo: "Assigner à un signataire",
          removeField: "Retirer le champ",
          removeSigner: "Retirer le signataire",
          resendSigner: "Renvoyer à ce signataire",
          signed: "Signé",
          namePlaceholder: "p. ex. Priya Natarajan",
          emailPlaceholder: "nom@entreprise.com",
          zoomIn: "Agrandir",
          zoomOut: "Réduire",
          hintTitle: "Presque prêt à envoyer",
          hintBody:
            "Ajoutez un signataire et placez au moins un champ avant l’envoi.",
          unassigned: "Non assigné",
          notFound: "Contrat introuvable.",
          pdfError: "Impossible de charger l’aperçu du document.",
          fieldTypes: {
            signature: "Signature",
            initial: "Paraphe",
            date: "Date",
          },
        },
        executed: {
          executedOn: "Exécuté",
          headTitle: "Ce contrat est exécuté",
          headSub:
            "Tous les signataires ont signé. Le document est scellé et verrouillé — aucune modification possible.",
          details: "Registre d’exécution",
          contractNo: "Nº de contrat",
          signers: "Signataires",
          signedOn: "signé",
          fingerprint: "Empreinte du document",
          fingerprintHint: "SHA-256 du PDF/A scellé",
          timestamp: "Horodatage de confiance",
          timestampHint: "Scellé et horodaté · RFC 3161",
          downloadSealed: "Télécharger la copie scellée",
          downloadCertificate: "Télécharger le certificat",
          verifyTitle: "Vérifier l’intégrité",
          verifySub:
            "Déposez le fichier scellé pour confirmer qu’il n’a pas changé depuis l’exécution. Rien n’est téléversé — le fichier est haché et comparé.",
          drop: "Déposez le PDF scellé ici",
          dropHint: "ou cliquez pour choisir · rehaché avec le registre",
          verifying: "Vérification…",
          matchTitle: "Ce fichier correspond au registre scellé",
          matchBody:
            "Le SHA-256 de ce fichier est identique à l’empreinte enregistrée. Il n’a pas été modifié depuis l’exécution.",
          mismatchTitle:
            "Ce fichier ne correspond pas — il a peut-être été modifié",
          mismatchBody:
            "Le SHA-256 de ce fichier diffère de l’empreinte enregistrée. Téléchargez une nouvelle copie scellée ci-dessus.",
          checkAnother: "Vérifier un autre fichier",
        },
        billing: {
          tabsLabel: "Sections du contrat",
          tabDocument: "Document",
          tabBilling: "Facturation",
          sectionTitle: "Conditions du contrat",
          lineItems: "Postes",
          client: "Client",
          clientHint:
            "Les factures émises à partir de ce contrat sont facturées à ce client.",
          clientPlaceholder: "Sélectionnez un client...",
          manageClients: "Gérer les clients",
          refreshClients: "Actualiser la liste des clients",
          currency: "Devise",
          currencyPlaceholder: "Sélectionnez une devise...",
          currencyHint:
            "Les postes et les paiements planifiés utilisent tous cette devise.",
          leadTime: "Délai d'émission",
          noClientTitle: "Aucun client sur ce contrat",
          noClientBody:
            "Les paiements ne peuvent pas être planifiés tant que ce contrat n’a pas de client. Choisissez-en un ci-dessous.",
          lockedNote:
            "Ce contrat a été envoyé : le client et la devise sont verrouillés. Le délai de facturation peut encore être modifié.",
          executedNote:
            "Ce contrat est entièrement signé : le client et la devise sont verrouillés. Le délai de facturation peut encore être modifié et s'applique aux factures qui ne sont pas encore générées.",
          voidedNote:
            "Ce contrat est annulé : ses conditions de facturation sont en lecture seule.",
          leadTimeInherit_one:
            "Valeur par défaut de l’organisation — {{count}}",
          leadTimeInherit_other:
            "Valeur par défaut de l’organisation — {{count}}",
          leadTimeUnit_one: "jour",
          leadTimeUnit_other: "jours",
          leadTimeDays_one: "{{count}} jour",
          leadTimeDays_other: "{{count}} jours",
          leadTimeOrgDefault_one:
            "La valeur par défaut de votre organisation est de {{count}} jour.",
          leadTimeOrgDefault_other:
            "La valeur par défaut de votre organisation est de {{count}} jours.",
          leadTimeOverride: "Personnaliser",
          leadTimeUseDefault: "Valeur par défaut",
          leadTimeHelp:
            "Les factures sont émises ce nombre de jours avant l’échéance du paiement. Toute modification met à jour la date d’émission de chaque facture non encore générée.",
          leadTimeHelpReadOnly:
            "Les factures sont émises ce nombre de jours avant l’échéance du paiement.",
          leadTimeRange:
            "Saisissez un nombre entier de jours entre {{min}} et {{max}}.",
          currencyChangeTitle: "Changer la devise",
          currencyChangeBody:
            "Changer la devise réétiquette chaque poste et chaque paiement planifié de ce contrat. Les montants restent les mêmes — seule la devise change.",
          currencyChangeConfirm: "Changer la devise",
          columns: {
            sku: "UGS",
            name: "Description",
            quantity: "Qté",
            unitPrice: "Prix unitaire",
            amount: "Montant",
          },
          addItem: "Ajouter un poste",
          addDisabledTooltip:
            "Définissez une devise sur ce contrat avant d’ajouter des postes.",
          itemNamePlaceholder: "Nom du poste",
          itemDescriptionPlaceholder: "Description",
          itemNameRequired:
            "Saisissez un nom de poste d’au plus 100 caractères.",
          itemSkuTooLong: "Saisissez une UGS d’au plus 100 caractères.",
          itemDescriptionTooLong:
            "Saisissez une description d’au plus 5 000 caractères.",
          itemQuantityInvalid: "Saisissez une quantité supérieure à zéro.",
          itemUnitPriceInvalid: "Saisissez un prix unitaire de zéro ou plus.",
          totalLabel: "Total",
          reorderItem: "Réordonner le poste",
          discardItem: "Abandonner cette ligne",
          removeItem: "Supprimer le poste",
          removeItemTitle: "Supprimer le poste",
          removeItemBody: "Voulez-vous vraiment supprimer « {{name}} » ?",
          rowMenuLabel: "Actions du poste",
          empty: {
            noCurrencyTitle: "Définissez d’abord une devise",
            noCurrencyBody:
              "Un contrat doit avoir une devise avant de pouvoir contenir des postes. Définissez-en une ci-dessus pour commencer à chiffrer ce contrat.",
            setCurrency: "Définir une devise",
            noItemsTitle: "Aucun poste pour l’instant",
            noItemsBody:
              "La valeur du contrat est la somme de ses postes. Ajoutez le premier pour commencer.",
          },
          itemsLoadFailed: "Impossible de charger les postes",
          itemsLoadFailedBody:
            "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
          retry: "Réessayer",
          saveFailed:
            "Désolé, cette modification n’a pas pu être enregistrée en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
          schedule: {
            title: "Calendrier de paiement",
            columns: {
              description: "Description",
              due: "Échéance",
              invoice: "Facture",
              amount: "Montant",
            },
            scheduledTotal: "Planifié",
            remainder:
              "Il reste {{remaining}} à planifier sur une valeur de contrat de {{value}}.",
            overScheduled:
              "Le calendrier totalise {{scheduled}}, soit plus que la valeur du contrat de {{value}}.",
            valueUnknown:
              "Les montants en pourcentage ne peuvent être calculés tant que la valeur du contrat est inconnue.",
            dueOnSigning: "À la signature",
            dueAfterSigning_one: "{{count}} jour après la signature",
            dueAfterSigning_other: "{{count}} jours après la signature",
            dueOnDate: "Le {{date}}",
            invoiceSameDay: "Facture émise le jour de l’échéance",
            invoiceEarlier_one: "Facture émise {{count}} jour avant",
            invoiceEarlier_other: "Facture émise {{count}} jours avant",
            datesOnceSigned: "Dates exactes une fois signé",
            issuedAndDue: "Émise le {{issued}} · échéance {{due}}",
            generatedOn: "Facture créée le {{at}}",
            warnDueOnArrival:
              "Cette facture sera émise le jour de son échéance : le client la recevra déjà échue.",
            warnShortenedWindow_one:
              "La facture sera émise à la date de signature : le client disposera de {{count}} jour, et non de {{lead}}.",
            warnShortenedWindow_other:
              "La facture sera émise à la date de signature : le client disposera de {{count}} jours, et non de {{lead}}.",
            leadLabel: "Envoyer la facture avant l’échéance",
            leadInherit_one: "Utiliser la valeur du contrat — {{count}} jour",
            leadInherit_other:
              "Utiliser la valeur du contrat — {{count}} jours",
            leadOverride: "Définir un délai personnalisé",
            leadUseDefault: "Utiliser la valeur du contrat",
            leadHelp:
              "La facture est émise ce nombre de jours avant l’échéance, puis reportée au jour ouvrable suivant.",
            addPayment: "Ajouter un paiement",
            addDisabledNoClient:
              "Ajoutez un client à ce contrat avant de planifier des paiements.",
            addDisabledNoCurrency:
              "Définissez une devise sur ce contrat avant de planifier des paiements.",
            addDisabledNoClientOrCurrency:
              "Ajoutez un client et définissez une devise avant de planifier des paiements.",
            addDisabledVoided:
              "Ce contrat est annulé; son calendrier est en lecture seule.",
            addDisabledFullyScheduled:
              "La totalité de la valeur du contrat est déjà planifiée. Augmentez la valeur du contrat ou modifiez un paiement pour libérer de la place.",
            fieldDescription: "Description",
            fieldDescriptionPlaceholder: "Acompte...",
            fieldTrigger: "Échéance du paiement",
            triggerAfterSigning: "Un nombre de jours après la signature",
            triggerFixedDate: "À une date fixe",
            fieldOffsetDays: "Jours après la signature",
            offsetHelp:
              "Entrez 0 pour un paiement dû à la date de signature. Le jour est la seule unité : trois mois correspondent à 90 jours.",
            fieldFixedDueDate: "Date d’échéance",
            fieldAmountType: "Type de montant",
            amountTypeFixed: "Un montant fixe",
            amountTypePercentage: "Un pourcentage de la valeur du contrat",
            fieldAmount: "Montant",
            fieldPercentage: "Pourcentage",
            percentageLivePreview:
              "Cela représente {{amount}} aujourd’hui. Le montant sera figé lors de la génération de la facture.",
            percentageLocksOnSave:
              "La valeur actuelle s’affichera une fois ce paiement enregistré.",
            percentageNoValue:
              "La valeur du contrat n’est pas encore connue; ce montant ne peut être calculé.",
            fieldAutoSend: "Envoyer automatiquement cette facture au client",
            autoSendHelp:
              "La facture sera envoyée par courriel au client à sa date d’émission, sans autre validation.",
            save: "Enregistrer le paiement",
            cancelAction: "Annuler",
            descriptionRequired:
              "Entrez une description d’au plus 255 caractères.",
            amountInvalid: "Entrez un montant supérieur à zéro.",
            percentageInvalid: "Entrez un pourcentage entre 0 et 100.",
            dueDateRequired: "Choisissez une date d’échéance.",
            saveFailed:
              "Désolé, ce paiement n’a pas pu être enregistré en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
            statusGenerated: "Facturé",
            statusCancelled: "Annulé",
            autoSendBadge: "Envoi automatique par courriel",
            lockedIn: "Figé lors de la création de la facture.",
            locksOnGenerate: "Sera figé lors de la génération de la facture.",
            rowMenuLabel: "Actions du paiement planifié",
            viewInvoice: "Voir la facture",
            edit: "Modifier le paiement",
            generate: "Générer maintenant",
            cancelPayment: "Annuler le paiement",
            deletePayment: "Supprimer le paiement",
            menuNotExecuted:
              "Disponible une fois que tous les signataires ont signé.",
            menuAlreadyInvoiced: "Ce paiement a déjà été facturé.",
            menuCancelled: "Ce paiement est annulé.",
            menuVoided: "Ce contrat est annulé.",
            menuNoInvoiceYet: "Aucune facture n’a encore été créée.",
            cancelBody:
              "Voulez-vous vraiment annuler ce paiement planifié? Il cessera de compter dans le calendrier et aucune facture ne sera créée.",
            deleteBody: "Voulez-vous vraiment supprimer ce paiement planifié?",
            generateTitle: "Générer la facture",
            generateSubtitle:
              "Vérifiez ces informations avant la création de la facture.",
            generateAmount: "Montant",
            generateClient: "Client",
            generateDueDate: "Échéance de la facture",
            generateDelivery: "Envoi",
            generateWillEmail:
              "Cette facture sera envoyée par courriel au client.",
            generateWillNotEmail:
              "Cette facture ne sera pas envoyée par courriel. Vous pourrez l’envoyer depuis la facture.",
            generateFailed:
              "Désolé, cette facture n’a pas pu être générée en raison d’une erreur de notre côté. Veuillez réessayer plus tard.",
            emptyTitle: "Aucun paiement planifié",
            emptyBody:
              "Ajoutez le premier pour indiquer quand ce contrat sera facturé. Invup crée les factures à l’avance pour vous.",
            blockedBodyNoClient:
              "Un paiement planifié a besoin d’un client à facturer.",
            blockedBodyNoCurrency:
              "Un paiement planifié a besoin d’une devise de facturation.",
            blockedBodyNeither:
              "Un paiement planifié a besoin d’un client à facturer et d’une devise de facturation.",
            setClient: "Définir un client",
            loadFailed: "Impossible de charger le calendrier de paiement",
            loadFailedBody:
              "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
          },
          burndown: {
            title: "Progression de la facturation",
            value: "Valeur du contrat",
            scheduled: "Planifié",
            unscheduled: "Non planifié",
            invoiced: "Facturé",
            paid: "Payé",
            outstanding: "Solde impayé",
            overScheduled: "Dépasse la valeur du contrat",
            emptyTitle: "Rien à facturer pour l’instant",
            emptyBody:
              "La progression de la facturation s’affichera une fois que ce contrat aura une devise et une valeur.",
            unavailableTitle: "Progression indisponible",
            unavailableBody:
              "Un élément de ce contrat est dans une devise différente : la progression de la facturation ne peut pas être calculée. D’autres sections peuvent tout de même afficher les montants qu’elles arrivent à totaliser. Communiquez avec le soutien pour le faire corriger.",
            loadFailed:
              "Impossible de charger la progression de la facturation",
            loadFailedBody:
              "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
            meter: {
              paid: "Payé",
              outstanding: "Solde dû",
              share: "({{percent}} %)",
              shareUnderOne: "(< 1 %)",
              shareOverNinetyNine: "(> 99 %)",
              total: "sur {{amount}} facturé",
              nothingInvoiced:
                "Rien n’a encore été facturé. Cette barre se remplit à mesure que les factures sont émises selon l’échéancier.",
              settled: "Tout ce qui a été facturé est payé.",
              overpaid: "{{amount}} de plus a été payé que facturé.",
            },
          },
          invoices: {
            title: "Factures générées",
            columns: {
              invoice: "Facture",
              issued: "Date d’émission",
              due: "Échéance",
              amount: "Montant",
              status: "Statut",
            },
            statusDraft: "Brouillon",
            statusSent: "Envoyée",
            statusPaid: "Payée",
            partiallyPaid: "{{amount}} payé",
            emptyTitle: "Aucune facture pour l’instant",
            emptyBodyPending:
              "Les factures apparaîtront ici une fois que tous les signataires auront signé et qu’un paiement planifié arrivera à échéance.",
            emptyBodyExecuted:
              "Les factures apparaîtront ici à mesure que les paiements planifiés arriveront à échéance.",
            emptyBodyVoided:
              "Ce contrat est annulé : aucune autre facture ne sera émise.",
            loadFailed: "Impossible de charger les factures générées",
            loadFailedBody:
              "Désolé, l’erreur vient de notre côté. Réessayez dans un instant.",
          },
        },
        contractsDeleted: "Contrats supprimés",
        reminderSent: "Rappel envoyé",
        signerRemoved: "Signataire retiré",
        fieldRemoved: "Champ retiré",
        itemRemoved: "Poste supprimé",
        itemsRemoved: "Postes supprimés",
        scheduledPaymentRemoved: "Paiement planifié supprimé",
        scheduledPaymentCancelled: "Paiement planifié annulé",
        invoiceGenerated: "Facture générée",
      },
      forms: {
        formActions: "Actions du formulaire",
        addQuestion: "Ajouter une question",
        addQuestionDropdownLabel:
          "Ajouter une question - Choisir le type de question",
        openFormInBrowser: "Ouvrir le formulaire dans le navigateur",
        formNeedsToBePublished:
          "Le formulaire doit être publié avant de pouvoir être ouvert dans le navigateur.",
        questionTypes: {
          text: "Texte",
          textarea: "Texte descriptif",
          single_select_radio: "Sélection unique (bouton radio)",
          multi_select_checkbox: "Sélection multiple (case à cocher)",
          file: "Téléversement de fichier",
          image: "Téléversement d'image",
        },
      },
      timeEntries: {
        timeLoggedTitle: "Temps enregistré",
        createSuccess: "Entrée de temps créée avec succès",
        downloadCsv: "Télécharger le CSV",
        exportError:
          "Désolé, cette exportation n'a pas pu être générée en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
        funConfirmations: {
          "1": "Tu es génial(e) — temps enregistré.",
          "2": "Et voilà — encore une au compteur.",
          "3": "Noté. Le toi de demain te remercie.",
          "4": "Temps capturé. En avant !",
          "5": "Regarde-toi, toujours au top.",
          "6": "Parfait. Ce sera utile à la facturation.",
          "7": "Enregistré. Offre-toi un café.",
          "8": "Et hop, ces minutes sont dans la boîte.",
          "9": "Sauvegardé. Ta future facture te dit merci.",
          "10": "Temps bien suivi.",
        },
      },
      expenses: {
        currency: "Devise",
        invoiced: "facturée",
        statusDraft: "brouillon",
        bulk: {
          addToInvoice: "Ajouter à une facture existante",
          oneClient:
            "Choisissez des dépenses d'un seul client — une facture appartient à un seul client.",
          notInvoiceable:
            "Seules les dépenses enregistrées, non facturées et dans une même devise peuvent être ajoutées à une facture.",
          chooseInvoice: {
            title: "Choisir une facture",
            subtitle: "Factures brouillon pour {{client}}, en {{currency}}.",
            empty: "Aucune facture brouillon pour ce client.",
            itemCount_one: "{{count}} ligne",
            itemCount_other: "{{count}} lignes",
          },
          append: "Ajouter à {{number}}",
        },
      },
      invoices: {
        downloadCsv: "Télécharger le CSV",
        exportError:
          "Désolé, cette exportation n'a pas pu être générée en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
        fromContract: "Provenant du contrat",
        generatedFromContract: "Générée à partir du contrat {{number}}",
        generatedFromAContract: "Générée à partir d’un contrat",
        uploadInvoiceLogo: "Téléverser le logo de la facture",
        deleteInvoiceLogo: "Supprimer le logo de la facture",
        addExpenses: {
          toastSuccess: "Dépenses ajoutées à la facture.",
        },
        canvas: {
          addExpensesTrigger: "Ajouter des dépenses",
          addTaxNonTaxableHint:
            "Cette ligne n'est pas taxable — le montant de la dépense inclut déjà la taxe payée.",
          fromExpenses: "Depuis les dépenses du client",
          expenseSource: "dépense",
          addExpenses: {
            title: "Ajouter des dépenses",
            subtitle: "Dépenses facturables pour {{client}}, en {{currency}}.",
            filterProject: "Projet",
            filterProjectAll: "Tous les projets",
            filterFrom: "Du",
            filterTo: "Au",
            currencyNote: "Seules les dépenses en {{currency}} sont affichées.",
            currencyNoteFx: "Les autres devises arriveront bientôt.",
            hiddenCount_one:
              "{{count}} dépense dans une autre devise est masquée.",
            hiddenCount_other:
              "{{count}} dépenses dans d'autres devises sont masquées.",
            colVendor: "Fournisseur",
            colDate: "Date",
            colAmount: "Montant",
            selectAll: "Tout sélectionner",
            receipts_one: "{{count}} reçu",
            receipts_other: "{{count}} reçus",
            taxable: "Taxable",
            taxableHint:
              "Appliquer les taxes de cette facture aux lignes ajoutées.",
            includeReceipts: "Inclure les reçus",
            includeReceiptsHint:
              "Joindre les reçus de chaque dépense à la facture.",
            selected: "{{count}} sélectionnée(s)",
            empty: "Aucune dépense facturable pour ce client.",
            emptyFiltered: "Aucune dépense ne correspond à ces filtres.",
            loading: "Chargement des dépenses…",
            confirm_one: "Ajouter {{count}} dépense",
            confirm_other: "Ajouter {{count}} dépenses",
            confirmEmpty: "Ajouter des dépenses",
            toastAdded_one: "{{count}} dépense ajoutée à la facture.",
            toastAdded_other: "{{count}} dépenses ajoutées à la facture.",
            fxHeld:
              "Seules les dépenses en {{currency}} peuvent être facturées pour l'instant — la conversion de devises n'est pas encore active.",
          },
        },
        groupingByEntry: "Par entrée de temps",
        useTimeEntryDescription:
          "Inclure les descriptions des entrées de temps",
        recurringInvoiceStatus: {
          active: "Active",
          paused: "En pause",
          archived: "Archivée",
        },
        recurringInvoiceActions: {
          pause: "Mettre en pause",
          resume: "Reprendre",
          archive: "Archiver",
          restore: "Restaurer",
          delete: "Supprimer",
        },
        recurringInvoiceViews: {
          main: "Principale",
          archived: "Archivées",
        },
        recurringInvoiceBulk: {
          pauseSelected: "Mettre en pause la sélection",
          archiveSelected: "Archiver la sélection",
          restoreSelected: "Restaurer la sélection",
          deleteSelected: "Supprimer la sélection",
        },
        recurringInvoiceDeleteConfirmationDynamicMessage_one:
          "Supprimer définitivement 1 facture récurrente ? Cette action est irréversible.",
        recurringInvoiceDeleteConfirmationDynamicMessage_other:
          "Supprimer définitivement {{count}} factures récurrentes ? Cette action est irréversible.",
        recurringInvoiceLifecycleSuccess_pause_one:
          "1 facture récurrente mise en pause.",
        recurringInvoiceLifecycleSuccess_pause_other:
          "{{count}} factures récurrentes mises en pause.",
        recurringInvoiceLifecycleSuccess_resume_one:
          "1 facture récurrente reprise.",
        recurringInvoiceLifecycleSuccess_resume_other:
          "{{count}} factures récurrentes reprises.",
        recurringInvoiceLifecycleSuccess_archive_one:
          "1 facture récurrente archivée.",
        recurringInvoiceLifecycleSuccess_archive_other:
          "{{count}} factures récurrentes archivées.",
        recurringInvoiceLifecycleSuccess_restore_one:
          "1 facture récurrente restaurée.",
        recurringInvoiceLifecycleSuccess_restore_other:
          "{{count}} factures récurrentes restaurées.",
        recurringInvoiceLifecycleSkipped_one: "{{count}} élément ignoré.",
        recurringInvoiceLifecycleSkipped_other: "{{count}} éléments ignorés.",
        recurringInvoiceLifecycleNoneUpdated:
          "Rien à faire — tous les éléments sélectionnés sont déjà dans cet état.",
        recurringInvoiceEmptyMain:
          "Aucune facture récurrente active ou en pause.",
        recurringInvoiceEmptyArchived: "Aucune facture récurrente archivée.",
        invoiceLeadDaysLabel: "Générer ce nombre de jours à l'avance",
        invoiceLeadDaysHelper:
          "Nombre de jours avant la date prévue où la prochaine facture doit être créée. Par défaut 7. Plage 0 à 90.",
        convertToRecurring: "Transformer en facture récurrente",
        sendReminder: "Envoyer un rappel",
        sendReminderConfirmation:
          "Envoyer un rappel de paiement au client pour cette facture ? Il recevra un courriel avec un lien pour payer.",
        sendReminderSuccess: "Rappel envoyé.",
        sendReminderNotSent:
          "Cette facture n'a pas encore été envoyée; un rappel ne peut donc pas être envoyé. Envoyez d'abord la facture.",
        sendReminderAlreadyPaid:
          "Cette facture est déjà payée; il n'y a aucun rappel à envoyer.",
        manualInvoiceReminder: "Rappel manuel",
        manualReminderInfo:
          "Le message envoyé lorsque vous envoyez manuellement un rappel depuis une facture. Les rappels manuels sont envoyés à la demande, en dehors du calendrier automatique ci-dessus.",
        convertPrefillBannerTitle: "Certains champs n'ont pas pu être repris",
        convertPrefillLoading: "Chargement de la facture source…",
      },
    },
    settings: {
      expenseBudgets: {
        currency: "Devise",
      },
      invoices: {
        contractInvoiceLeadTime: {
          label: "Délai d'émission des factures de contrat",
          help: "Utilisé par chaque contrat et chaque paiement qui n'a pas son propre délai, et relu chaque fois qu'une date de facturation est calculée — le modifier déplace donc aussi les paiements des contrats déjà signés mais pas encore facturés. Réglez-le à 0 pour émettre les factures le jour même de l'échéance, ce qui ne laisse au client aucun délai pour payer avant la date limite.",
          fieldLabel:
            "Envoyer les factures de contrat ce nombre de jours avant l'échéance du paiement",
          fieldHelper: "Valeur par défaut : 7. Plage : de 0 à 365.",
          rangeError: "Saisissez un nombre entier de jours entre 0 et 365.",
          requiredError:
            "Le délai d'émission des factures de contrat est requis.",
          saved:
            "Délai d'émission des factures de contrat mis à jour avec succès",
          serverError:
            "Désolé, ce paramètre n'a pas pu être enregistré en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
        },
      },
      services: {
        serviceActions: "Actions du service",
        archiveService: "Archiver",
        unarchiveService: "Désarchiver",
        deleteService: "Supprimer",
      },
      organization: {
        owner: "Propriétaire",
        editMember: {
          ownerTransferWarning:
            "Vous deviendrez administrateur dans {{organization}}. Cette action est immédiate.",
          ownerTransferTypeNamePrompt: "Tapez {{name}} pour confirmer.",
          ownerTransferNameMismatch:
            "Le nom de confirmation ne correspond pas.",
          transferOwnership: "Transférer la propriété",
          ownerTransferSuccess: "Propriété transférée à {{name}}.",
        },
        invitations: {
          heading: "Invitations",
          invitedAt: "Invitée le",
          inviter: "Invitée par",
          selectAll: "Sélectionner toutes les invitations de cette page",
          selectRow: "Sélectionner l'invitation pour {{email}}",
          deleteSelected: "Supprimer {{count}} invitations",
          pageOf: "Page {{current}} sur {{total}}",
          previous: "Précédent",
          next: "Suivant",
          filter: {
            all: "Toutes",
            pending: "En attente",
            expired: "Expirées",
            accepted: "Acceptées",
            declined: "Refusées",
            cancelled: "Annulées",
          },
          statusLabel: {
            pending: "En attente",
            expired: "Expirée",
            accepted: "Acceptée",
            declined: "Refusée",
            cancelled: "Annulée",
          },
          actions: {
            menuLabel: "Actions de l'invitation pour {{email}}",
            resend: "Renvoyer",
            changeRole: "Modifier le rôle",
            cancel: "Annuler",
            delete: "Supprimer",
          },
          changeRole: {
            title: "Modifier le rôle de l'invitation",
            description:
              "Choisissez un nouveau rôle pour l'invitation envoyée à {{email}}.",
            submit: "Mettre à jour le rôle",
            successToast: "Rôle de l'invitation mis à jour.",
          },
          empty: {
            pending: "Aucune invitation en attente.",
            expired: "Aucune invitation expirée.",
            accepted: "Aucune invitation acceptée.",
            declined: "Aucune invitation refusée.",
            cancelled: "Aucune invitation annulée.",
          },
          emptyAll: "Aucune invitation pour le moment.",
          cancelTitle: "Annuler l'invitation",
          cancelMessage:
            "Annuler l'invitation envoyée à {{email}}? Le destinataire ne pourra plus l'accepter.",
          confirmCancel: "Annuler l'invitation",
          deleteTitle: "Supprimer l'invitation",
          deleteMessage:
            "Supprimer l'invitation envoyée à {{email}}? Cette action est irréversible.",
          bulkDeleteTitle: "Supprimer les invitations",
          bulkDeleteMessage:
            "Supprimer {{count}} invitations? Cette action est irréversible.",
          confirmDelete: "Supprimer",
        },
        roles: {
          groupSystem: "Système",
          groupCustom: "Personnalisé",
          pageTitle: "Rôles",
          pageDescription:
            "Les rôles définissent ce que vos membres peuvent faire. Les rôles système sont intégrés; créez des rôles personnalisés pour affiner les accès.",
          createButton: "Créer un rôle",
          createButtonDisabledTooltip:
            "Passez à Pro pour créer des rôles personnalisés.",
          columnName: "Nom",
          columnMembers: "Membres",
          columnSystem: "Type",
          columnDescription: "Description",
          systemTooltip: "Rôle système — ne peut pas être modifié ou supprimé.",
          customBadge: "Personnalisé",
          upgradeCardHeadline: "Créez des rôles personnalisés",
          upgradeCardBody:
            "Définissez des rôles avec des permissions granulaires adaptées au fonctionnement de votre équipe. Disponible avec le forfait Pro.",
          upgradeCardCta: "Passer à Pro",
          rowEditAction: "Modifier le rôle",
          rowDeleteAction: "Supprimer le rôle",
          loading: "Chargement des rôles…",
          emptyTitle: "Aucun rôle pour le moment",
          emptyMessage: "Créez un rôle personnalisé pour commencer.",
          deleteModalTitle: "Supprimer le rôle",
          deleteModalMessage:
            "Supprimer le rôle {{name}}? Cette action est irréversible.",
          deleteConfirmButton: "Supprimer",
          blockedModalTitle: "Rôle utilisé",
          blockedModalMessage:
            "Le rôle {{name}} est attribué à {{memberCount}} membre(s) et à {{invitationCount}} invitation(s) en attente. Réaffectez-les avant de supprimer.",
          blockedModalCta: "Aller à la page de l’équipe",
          form: {
            createTitle: "Créer un rôle",
            editTitle: "Modifier le rôle",
            back: "Retour",
            nameLabel: "Nom",
            namePlaceholder: "p. ex. Responsable de la facturation",
            descriptionLabel: "Description",
            descriptionPlaceholder: "À quoi sert ce rôle?",
            permissionsLabel: "Permissions",
            permissionsHelp:
              "Choisissez ce que les membres ayant ce rôle peuvent faire. Sélectionner une action accorde automatiquement l’accès en consultation correspondant.",
            selectedCounter: "{{selected}} sur {{total}} sélectionné(s)",
            atLeastOne: "Sélectionnez au moins une permission.",
            loading: "Chargement des permissions…",
            createSubmit: "Créer le rôle",
            editSubmit: "Enregistrer les modifications",
            createSuccess: "Rôle créé.",
            updateSuccess: "Rôle mis à jour.",
          },
        },
        notifications: {
          title: "Acheminement des notifications",
          description:
            "Choisissez qui reçoit chaque notification d'invup concernant cette organisation. Laissez une règle vide pour utiliser la valeur par défaut : le propriétaire et les administrateurs de l'organisation.",
          save: "Enregistrer les modifications",
          cancel: "Annuler",
          saved: "Acheminement des notifications enregistré",
          addEmailPlaceholder: "Ajouter un courriel…",
          defaultBadge: "Par défaut : propriétaire + administrateurs",
          footerNote:
            "Appuyez sur Entrée ou sur la virgule pour ajouter chaque destinataire.",
          invalidEmail: "Saisissez une adresse courriel valide.",
          duplicate: "« {{email}} » est déjà un destinataire.",
          duplicateNotificationType:
            "Chaque notification ne peut être configurée qu'une seule fois par organisation.",
          groups: {
            invoices: "Factures",
            payments: "Paiements",
            forms: "Formulaires",
          },
          types: {
            invoice_sent: {
              label: "Facture envoyée",
              description:
                "Lorsqu'une facture est envoyée à un client (manuellement ou selon un horaire).",
            },
            invoice_paid: {
              label: "Facture payée",
              description:
                "Lorsqu'un client paie une facture et qu'une transaction est enregistrée.",
            },
            recurring_invoice_created: {
              label: "Facture récurrente créée",
              description:
                "Lorsqu'une nouvelle facture est générée à partir d'un horaire récurrent.",
            },
            contract_invoice_generated: {
              label: "Facture de contrat générée",
              description:
                "Lorsqu'une facture est générée à partir de l'échéancier de paiement d'un contrat.",
            },
            transaction_receipt: {
              label: "Reçu de transaction",
              description:
                "En copie conforme du courriel de reçu envoyé au client lorsqu'il paie une facture.",
            },
            form_submitted: {
              label: "Réponse au formulaire soumise",
              description:
                "Lorsqu'un client soumet une réponse à l'un de vos formulaires.",
            },
          },
        },
      },
      reportSubscriptions: {
        title: "Abonnements aux rapports",
        titleSingular: "Abonnement au rapport",
        subtitle:
          "Planifiez l'envoi récurrent de rapports de temps vers Slack.",

        create: "Nouvel abonnement",
        edit: "Modifier",
        delete: "Supprimer",
        runNow: "Exécuter",
        enable: "Activer",
        disable: "Désactiver",
        save: "Enregistrer",
        cancel: "Annuler",

        name: "Nom",
        schedule: "Horaire",
        destination: "Destination",
        groupedBy: "Regroupé par",
        period: "Période",
        status: "Statut",
        lastRun: "Dernière exécution",
        lastSuccess: "Dernier envoi",
        never: "Jamais",
        failures: "Échecs consécutifs",

        nameLabel: "Nom",
        namePlaceholder: "p. ex. Heures hebdomadaires par client",
        groupByLabel: "Regrouper par",
        groupBySecondaryLabel: "Puis regrouper par",
        groupBySecondaryHelp: "Niveau de regroupement secondaire (facultatif).",
        filtersLabel: "Filtres",
        filtersHelp: "Laissez un filtre vide pour tout inclure.",
        clientsLabel: "Clients",
        projectsLabel: "Projets",
        servicesLabel: "Services",
        membersLabel: "Membres",
        periodTypeLabel: "Type de période",
        periodTypeHelp:
          "La période civile couvre une plage nommée; la fenêtre glissante couvre les N derniers jours, semaines ou mois.",
        calendarPeriodLabel: "Période civile",
        windowUnitLabel: "Unité de la fenêtre",
        windowLengthLabel: "Longueur de la fenêtre",
        windowLengthHelp:
          "Combien d'unités ci-dessus inclure, p. ex. les 4 dernières semaines.",
        frequencyLabel: "Fréquence",
        dayOfWeekLabel: "Jour de la semaine",
        timeOfDayLabel: "Heure de la journée",
        timezoneNote:
          "Les envois utilisent le fuseau horaire de votre organisation ({{timezone}}).",
        timezoneSettingsLink:
          "Modifiez-le dans les paramètres de l'organisation.",
        channelLabel: "Canal Slack",
        channelIdLabel: "ID du canal",
        channelNameLabel: "Nom du canal",
        destinationHelp: "Les rapports sont publiés dans ce canal Slack.",

        dimension: {
          client: "Client",
          project: "Projet",
          member: "Membre",
          service: "Service",
        },
        periodType: {
          calendar: "Période civile",
          rolling: "Fenêtre glissante",
        },
        calendarPeriod: {
          this_week: "Cette semaine",
          month_to_date: "Mois à ce jour",
          last_week: "La semaine dernière",
          last_month: "Le mois dernier",
        },
        rollingUnit: {
          days: "Jours",
          weeks: "Semaines",
          months: "Mois",
        },
        frequency: {
          daily: "Quotidienne",
          weekly: "Hebdomadaire",
        },

        activeBadge: "Actif",
        disabledBadge: "Désactivé",
        pausedBadge: "Suspendu",
        pausedReason: {
          scope_lost:
            "Suspendu — vous n'avez plus accès aux données couvertes par ce rapport.",
          owner_inactive:
            "Suspendu — le propriétaire n'est plus actif dans cette organisation.",
          too_many_failures:
            "Suspendu — l'envoi a échoué plusieurs fois de suite.",
        },

        reconnectTitle: "Reconnectez Slack pour gérer les rapports",
        reconnectMessage:
          "Invup doit se reconnecter à votre espace de travail Slack avant de pouvoir livrer les abonnements aux rapports.",
        reconnectCta: "Reconnecter Slack",

        emptyTitle: "Aucun abonnement aux rapports pour l'instant",
        emptyMessage:
          "Créez un abonnement pour recevoir des rapports de temps planifiés dans Slack.",

        deleteSuccess: "Abonnements aux rapports supprimés",
        runNowSuccess: "Rapport en file d'attente — il sera livré sous peu.",
        enabledSuccess: "Abonnement au rapport activé",
        disabledSuccess: "Abonnement au rapport désactivé",

        addTitle: "Nouvel abonnement au rapport",
        editTitle: "Modifier l'abonnement au rapport",

        sectionWhat: "Quoi rapporter",
        sectionWhen: "Quand envoyer",
        sectionWhere: "Où envoyer",

        groupBySecondaryNone: "Aucun",
        selectPlaceholder: "Sélectionner…",

        channelIdPlaceholder: "p. ex. C0123ABCD",
        channelNamePlaceholder: "p. ex. #finance",
        channelIdHelp:
          "Dans Slack, ouvrez le canal → À propos → copiez l'ID du canal. Invup doit être membre du canal.",

        dayOfWeek: {
          "1": "Lundi",
          "2": "Mardi",
          "3": "Mercredi",
          "4": "Jeudi",
          "5": "Vendredi",
          "6": "Samedi",
          "7": "Dimanche",
        },

        scheduleDaily: "Tous les jours à {{time}}",
        scheduleWeekly: "{{day}} à {{time}}",
        rollingSummary: "{{count}} {{unit}}",

        enabledFilterLabel: "Activé",

        confirmDeleteTitle: "Supprimer l'abonnement ?",
        confirmDeleteTitle_plural: "Supprimer les abonnements ?",
        confirmDeleteMessage:
          "Cette action supprime définitivement l'abonnement. Elle est irréversible.",
        confirmDeleteMessage_plural:
          "Cette action supprime définitivement {{count}} abonnements. Elle est irréversible.",
        deleteError: "Impossible de supprimer les abonnements.",

        connectTitle: "Connecter Slack",
        connectMessage:
          "Connectez votre espace de travail Slack pour créer et livrer des abonnements aux rapports.",
        connectCta: "Connecter Slack",
        reconnectMissingScopes: "Autorisations manquantes : {{scopes}}",

        secondaryMustDiffer:
          "Le regroupement secondaire doit différer du regroupement principal.",
        rollingCountRange: "Entrez un nombre de 1 à {{max}}.",
        nameMaxLength: "Le nom ne doit pas dépasser 255 caractères.",
      },
    },
  },
  global: {
    addressLineOne: "Adresse Ligne Un",
    addressLineTwo: "Adresse Ligne Deux",
    back: "Retour",
    city: "Ville",
    country: "Pays",
    email: "E-mail",
    invupme: "invup",
    invoice: "Facture",
    maxLengthFieldErrorMessage:
      "Ce champ a dépassé la longueur maximale de caractères.",
    maxLengthWithValueFieldErrorMessage:
      "Ce champ ne peut accepter que {{value}} caractères.",
    name: "Nom",
    patternFieldErrorMessage: "Ce champ ne correspond pas au modèle requis.",
    phoneNumber: "Téléphone",
    requiredFieldErrorMessage: "{{value}} est requis.",
    continue: "Continuer",
    state: "État/Province",
    tagLine: "Slogan",
    zipCode: "Code postal",
    weSentYouAPasscode: "Nous vous avons envoyé un e-mail avec un code d'accès",
    organizationName: "Nom de l'organisation",
  },
  login: {
    welcomeBack: "Connectez-vous à Invup",
    pleaseProvideEmail:
      "Veuillez fournir votre adresse e-mail pour vous connecter",
    createNewAccount: "Créer un nouveau compte",
  },
  signup: {
    welcomeToInvup: "Bienvenue sur Invup",
    pleaseProvideEmail:
      "Veuillez fournir votre adresse e-mail pour créer un compte",
    useExitingAccount: "Connectez-vous avec un compte existant",
  },
  newOrganization: {
    getStartedTitle: "Commençons",
    getStartedMessage: "Créez votre première organisation pour commencer !",
    createOrganization: "Créer une organisation",
    createNewOrganizationTitle: "Créer une nouvelle organisation",
    createNewOrganizationMessage:
      "Ajoutez une autre organisation à votre compte",
  },
  timeline: {
    empty: "Aucune activité pour le moment",
    loading: "Chargement…",
    refresh: "Actualiser l'activité",
    filters: {
      from: "Du",
      to: "Au",
      reset: "Réinitialiser",
    },
    pagination: {
      previous: "Précédent",
      next: "Suivant",
    },
  },
  activity: {
    title: "Activité",
    description:
      "Une chronologie des modifications dans cette organisation — qui a fait quoi, et quand.",
  },
  teamMemberDetails: {
    activityHeading: "Activité",
  },
  successfulTeamMemberInvitationResend: "Invitation renvoyée",
  successfulTeamMemberInvitationCancel: "Invitation annulée",
  successfulTeamMemberInvitationDelete: "Invitation supprimée",
  successfulTeamMemberInvitationsBulkDelete: "Invitations supprimées",
  successfulRoleDelete: "Rôle supprimé",
  ...rayaLucariaFrCA,
};
